export const MAX_CHAT_ATTACHMENTS = 10;

export const initialState: MBChatInputState = {
  contentFromDraftId: {},
  editContentFromDraftId: {},
  urgentFromDraftId: {},
  attachmentsFromDraftId: {},
  isGIFModalVisibleFromDraftId: {},
};

export function chatInputReducer(
  state: MBChatInputState = initialState,
  action: ChatInputAction,
): MBChatInputState {
  switch (action.type) {
    case 'CHAT:INPUT:UPDATE_CONTENT': {
      const { draftId, content } = action.value;
      return {
        ...state,
        contentFromDraftId: {
          ...state.contentFromDraftId,
          [draftId]: content ?? '',
        },
      };
    }
    case 'CHAT:INPUT:UPDATE_EDIT_CONTENT': {
      const { draftId, content } = action.value;
      return {
        ...state,
        editContentFromDraftId: { ...state.editContentFromDraftId, [draftId]: content },
      };
    }
    case 'CHAT:INPUT:UPDATE_URGENT': {
      const { draftId, urgent } = action.value;
      return {
        ...state,
        urgentFromDraftId: { ...state.urgentFromDraftId, [draftId]: urgent },
      };
    }
    case 'CHAT:INPUT:ADD_ATTACHMENTS': {
      const { draftId, attachments: newAttachments } = action.value;
      const oldAttachments = state.attachmentsFromDraftId[draftId] || [];
      const availableSlots = MAX_CHAT_ATTACHMENTS - oldAttachments.length;
      const attachmentsToAdd = availableSlots > 0 ? newAttachments.slice(0, availableSlots) : [];
      return {
        ...state,
        attachmentsFromDraftId: {
          ...state.attachmentsFromDraftId,
          [draftId]: [...oldAttachments, ...attachmentsToAdd],
        },
      };
    }
    case 'CHAT:INPUT:REMOVE_ATTACHMENT': {
      const { draftId, attachment } = action.value;
      const oldAttachments = state.attachmentsFromDraftId[draftId] || [];
      const attachments = oldAttachments.filter(a => a.fileKey !== attachment.fileKey);
      return {
        ...state,
        attachmentsFromDraftId: { ...state.attachmentsFromDraftId, [draftId]: attachments },
      };
    }
    case 'CHAT:INPUT:CLEAR_ATTACHMENTS': {
      const { draftId } = action.value;
      return {
        ...state,
        attachmentsFromDraftId: {
          ...state.attachmentsFromDraftId,
          [draftId]: [],
        },
      };
    }

    case 'CHAT:INPUT:TOGGLE_GIF_MODAL': {
      const { draftId, visible } = action.value;
      return {
        ...state,
        isGIFModalVisibleFromDraftId: {
          ...state.isGIFModalVisibleFromDraftId,
          [draftId]: visible,
        },
      };
    }

    default:
      return state;
  }
}
